import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

const NotFound = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '70vh',
                textAlign: 'center',
                p: 3
            }}
        >
            <Paper
                sx={{
                    p: { xs: 4, md: 8 },
                    borderRadius: 4, // 32px para look M3
                    maxWidth: 500,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 3
                }}
            >
                <SentimentVeryDissatisfiedIcon sx={{ fontSize: 80, color: 'primary.main', opacity: 0.8 }} />
                <Typography variant="h4" fontWeight="bold">{t('err_404_title')}</Typography>
                <Typography variant="body1" color="textSecondary">{t('err_404_msg')}</Typography>
                <Button variant="contained" size="large" onClick={() => navigate('/')}>
                    {t('err_404_btn')}
                </Button>
            </Paper>
        </Box>
    );
};

export default NotFound;